export default __webpack_public_path__ + "7152b9242081d6f415d662610caccabb.png";